import Main from './main.vue';
import store from './store';
export default (Vue, component, isAnyDialog = false) => {
  let componentTmp = component;
  const div = document.createElement('div');
  const el = document.createElement('div');
  div.appendChild(el);
  document.body.appendChild(div);

  if (!component) {
    throw new Error('component 组件不能为空');
  }
  if (isAnyDialog) {
    component = Main;
  }
  const ComponentConstructor = Vue.extend(component);
  return (propsData = {}, parent = undefined) => {
    if (propsData.component) {
      throw new Error('this.$dialog 的属性 component 属于内置属性，不能传递 component 属性，入需要传递组件，请使用其它参数名');
    }
    if (isAnyDialog) {
      store.dialog.propsData = propsData;
      store.dialog.component = componentTmp;
    }
    let instance = new ComponentConstructor({
      propsData,
      parent,
      router: window.$ROUTER,
    }).$mount(el);

    const destroyDialog = () => {
      if (instance && div.parentNode) {
        instance.$destroy();
        instance = null;
        div.parentNode && div.parentNode.removeChild(div);
      }
    };

    // visible控制
    if (instance['visible'] !== undefined) {
      // 支持sync/v-model
      instance.$watch('visible', val => {
        !val && destroyDialog();
      });
      Vue.nextTick(() => (instance['visible'] = true));
    }

    return new Promise((resolve, reject) => {
      instance.$once('done', data => {
        destroyDialog();
        resolve(data);
      });
      instance.$once('cancel', data => {
        destroyDialog();
        reject(data);
      });
    });
  };
};
